<div class="pre-login">
  <div class="pre-login-col-1 h-100">
    <left-panel-onboarding></left-panel-onboarding>
  </div>
  <div class="pre-login-col-2">
  </div>
  <div class="pre-login-col-3">
    <div class="onboarding-canvas">
      <grid-row class="mt-30">
        <grid-col col="8">
          <div class="font-400 font-size-20px line-h-25">
            {{ "ChangeCardPIN" | translate }}
          </div>
          <div class="font-400 font-size-14px color-base-400 mt-10 line-h-20">
            {{ "PleaseEnter4-digitPIN" | translate }}
          </div>
        </grid-col>
      </grid-row>
      <div class="form-group mt-50">
        <label class="no-mark">
          {{ "CurrentPIN" | translate }}
        </label>
        <input type="text" placeholder="Please enter">
      </div>
      <div class="form-group mt-30">
        <label class="no-mark">
          {{ "NewPIN" | translate }}
        </label>
        <input type="text" placeholder="Please enter">
      </div>
      <div class="form-group mt-30">
        <label class="no-mark">
          {{ "ConfirmNewPIN" | translate }}
        </label>
        <input type="text" placeholder="Please enter">
      </div>
      <grid-row class="justify-content-between align-item-center mt-50">
        <grid-col col="auto">
          <div class="mt-15">
            <button class="btn-back" (click)="back()">
              <i class="icon-back"></i>
            </button>
          </div>
        </grid-col>
        <grid-col col="9">
          <button class="btn-dft" (click)="this.showModal(5)">
            {{ "Next" | translate }}
          </button>
        </grid-col>
      </grid-row>
    </div>
  </div>
</div>

<!-- Success Card pin Modal Open -->
<modal modalID="5" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="LOG OUT">
  <div class="text-align-center">
    <ng-icon iconClass="icon-suspend-black" width="72" height="72"></ng-icon>
    <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
      {{ "YourAccountSuspended" | translate }}
    </div>
    <div class="font-400 font-size-14px line-h-20 color-base-500 p-10">
      {{ "YouHaveExceededMaximumAttempts" | translate }}
    </div>
  </div>
</modal>